var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandHeartRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7425_11772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5711 11.1963L58.5711 11.1963C56.9289 9.65068 54.8284 8.91016 52.7161 8.91016C50.3396 8.91016 47.9408 9.84678 46.1519 11.638L45.582 12.2079L45.0118 11.6359L45.0115 11.6356C43.2227 9.84677 40.8239 8.91016 38.4475 8.91016C36.3352 8.91016 34.2346 9.65068 32.5924 11.1963L32.5924 11.1963C28.9873 14.5898 28.9239 20.2668 32.3997 23.7426L45.405 36.7479L45.5818 36.9247L45.7585 36.7479L58.7639 23.7426C62.2396 20.2668 62.1762 14.5898 58.5711 11.1963ZM56.7952 21.774L45.5818 32.9874L34.3683 21.774C33.2192 20.6248 32.6013 19.0977 32.6254 17.4724C32.6495 15.8475 33.3154 14.3401 34.5022 13.2235L34.5025 13.2233C35.5459 12.2388 36.9457 11.6946 38.4475 11.6946C40.1511 11.6946 41.8283 12.392 43.0405 13.6042C43.0405 13.6042 43.0406 13.6042 43.0406 13.6043L43.7873 14.3533L43.7876 14.3536L45.4027 15.9687L45.5795 16.1454L45.7563 15.9687L47.3714 14.3536L48.1184 13.6066C49.3329 12.392 51.008 11.6946 52.7138 11.6946C54.2155 11.6946 55.6154 12.2387 56.6613 13.2234L56.6613 13.2235C57.8481 14.3401 58.514 15.8475 58.5381 17.4724C58.5623 19.0977 57.9443 20.6248 56.7952 21.774Z",
    fill: "url(#paint0_linear_7425_11772)",
    stroke: "url(#paint1_linear_7425_11772)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1197 44.9806C68.1812 44.684 67.096 45.0117 66.1357 45.5373C66.0213 45.6 65.7105 45.8253 65.2319 46.1941C64.7621 46.5561 64.149 47.0418 63.4424 47.609C62.0296 48.7431 60.2468 50.2001 58.4973 51.6391C56.7479 53.078 55.0324 54.4984 53.7542 55.5591C53.1151 56.0894 52.5853 56.5298 52.2154 56.8377L51.7865 57.1946L51.6739 57.2885L51.645 57.3125L51.6377 57.3186L51.6359 57.3201L51.6354 57.3205C51.6353 57.3206 51.6353 57.3206 51.4752 57.1286L51.6353 57.3206L51.5657 57.3786L51.4752 57.3786L38.6869 57.3809H38.6869C36.7345 57.3809 35.1633 55.7996 35.1633 53.8573C35.1633 52.5827 35.6069 51.6202 36.2803 50.9769C36.9502 50.337 37.8322 50.0276 38.6869 50.0276H46.0885C46.6652 50.0276 47.3853 49.8563 47.9538 49.5066C48.5185 49.1594 48.9042 48.658 48.9042 47.9931C48.9042 47.4903 48.7374 47.1241 48.4927 46.8493C48.2433 46.5693 47.9025 46.3732 47.544 46.2375C47.1865 46.1022 46.8245 46.0319 46.5477 45.9958C46.277 45.9605 46.0945 45.9587 46.0886 45.9587L46.0885 45.9587C43.9106 45.9587 42.6033 45.9633 41.8406 45.9678C41.4593 45.9701 41.2143 45.9724 41.0647 45.9741C40.99 45.9749 40.9391 45.9757 40.9071 45.9761L40.8725 45.9767L40.8646 45.9769L40.8628 45.9769L40.8624 45.9769L69.1197 44.9806ZM69.1197 44.9806L53.8698 62.0874L69.1197 44.9806ZM71.3054 42.9868L71.305 42.9866C69.1953 41.5568 66.7295 41.9808 64.6 43.21C64.0586 43.5225 62.9026 44.4021 61.4922 45.5269C60.0742 46.6577 58.3802 48.0517 56.7525 49.4073C55.1245 50.763 53.5619 52.0809 52.4063 53.0599C51.8285 53.5494 51.3524 53.9542 51.0207 54.2367C50.9617 54.2869 50.9073 54.3333 50.8577 54.3756C50.7679 54.4521 50.6938 54.5153 50.6369 54.5638L50.572 54.6193L38.8765 54.6216C38.8765 54.6216 38.8765 54.6216 38.8764 54.6216C38.6912 54.6216 38.4662 54.5125 38.2787 54.3203C38.0914 54.1284 37.9843 53.8969 37.9843 53.7088C37.9843 53.2132 38.4236 52.8166 38.8765 52.8166H46.0885C47.4006 52.8166 48.7924 52.3902 49.8614 51.5777C50.9354 50.7615 51.6886 49.5499 51.6886 47.9977C51.6886 46.3576 50.9383 45.1435 49.8586 44.347C48.7863 43.5561 47.3942 43.1788 46.0885 43.1788C43.8985 43.1788 42.5902 43.1834 41.8291 43.188C41.4485 43.1902 41.2047 43.1925 41.0558 43.1943C40.9813 43.1951 40.9306 43.1958 40.8983 43.1963L40.8632 43.1969L40.8547 43.1971L40.8546 43.1971C39.0984 43.197 37.3789 43.0884 36.0703 42.3883L36.0704 42.3882L36.0664 42.3862C34.2035 41.4314 32.0581 40.8921 29.7707 40.8921C25.9311 40.8921 22.4885 42.4235 20.1246 44.8447L7.8246 56.955L7.64507 57.1318L7.82322 57.3099L21.5299 71.0166L21.7066 71.1934L21.8834 71.0166L26.3791 66.5209H49.41C51.774 66.5209 54.0558 65.6532 55.8218 64.0843L55.8326 64.0746L55.8423 64.0637L71.4973 46.5024C72.5567 45.5493 72.5023 43.8011 71.3054 42.9868Z",
    fill: "url(#paint2_linear_7425_11772)",
    stroke: "url(#paint3_linear_7425_11772)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7425_11772",
    x1: 61.0737,
    y1: 28.8618,
    x2: 30.0898,
    y2: 28.8618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7425_11772",
    x1: 61.0737,
    y1: 28.8618,
    x2: 30.0898,
    y2: 28.8618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7425_11772",
    x1: 72.0001,
    y1: 62.4873,
    x2: 8,
    y2: 62.4873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7425_11772",
    x1: 72.0001,
    y1: 62.4873,
    x2: 8,
    y2: 62.4873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7425_11772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHeartRainbow);
export default __webpack_public_path__ + "static/media/hand-heart-rainbow.5821e12e0eff8e50dfc27b3e616de3a5.svg";
export { ForwardRef as ReactComponent };